<template>
  
  <div>
    <!-- Menu "public" -->
    <div :class="{mme}">
      <div class="nav">
        <div class="nav-inner">
          <a href="http://cmem-mat.info">
            <img v-if="!mme" src="@/assets/logo-tk-alpha.png" />
            <img v-else src="https://ligneetlumiere.fr/wp-content/uploads/2020/07/ligne-lumiere-logo1.png" />
          </a>
          <span>Bonjour <strong>{{$store.state.self.firstname}} {{$store.state.self.name}}</strong></span>
        </div>
      </div>
      <div class="breadcrumb">
        <div :class="isActive('Accueil')">
          <div class="dropdown-title"><a href="http://cmem-mat.info">ACCUEIL</a></div>
        </div>
        <div v-for="groupe in moduleGroups" :key="groupe.Id" :class="isActive(groupe.NomGroupe)" v-if="$store.state.self.isAdmin">
          <div class="dropdown-title"><a>{{ groupe.NomGroupe.toUpperCase() }}</a></div>
          <div class="dropdown-sub">
            <div v-for="module in groupe.Modules" :key="module.Id" class="dropdown-option">
              <router-link :to="'/' + module.Url">{{ module.Title.toUpperCase() }}</router-link>
              <!--<a @click="$router.push(module.Url)">{{ module.Title.toUpperCase() }}</a>-->
            </div>
          </div>
        </div>
        <div class="dropdown" v-if="$store.state.self.isAdmin">
          <div class="dropdown-title">
            <a :href="'https://maps.cmem-mat.info/?login=' + login + '&email=' + email + '&autologinHash=' + autologinHash + '&odw=1'">MAPS</a>
          </div>
        </div>
      </div>
    </div>
    <!-- Menu admin -->
    <div v-if="false">
      <div class="nav-admin">


        <!-- Infos utilisateur -->
        <div class="user-infos">
          <div class="user-infos-selected">
            <span id="userInfos">Bonjour {{$store.state.self.firstname}} {{$store.state.self.name}}</span>
          </div>
        </div>

        <!-- Logo -->
        <div class="navbar-brand">
          <img src="@/assets/logo-alt.png" />
        </div>

      </div>
      <div class="breadcrumb">
        <div :class="isActive('Accueil')">
          <div class="dropdown-title"><a href="http://cmem-mat.info">ACCUEIL</a></div>
        </div>
        <div v-for="groupe in moduleGroups" :key="groupe.Id" :class="isActive(groupe.NomGroupe)" v-if="$store.state.self.isAdmin">
          <div class="dropdown-title"><a>{{ groupe.NomGroupe.toUpperCase() }}</a></div>
          <div class="dropdown-sub">
            <div v-for="module in groupe.Modules" :key="module.Id" class="dropdown-option">
              <a @click="$router.push(module.Url)">{{ module.Title.toUpperCase() }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getModulesInGroups } from "@/utils/module"

  export default {
    name: "Navbar",
    props: { mme: Boolean },
    data() {
      return {
        moduleGroups: [],
        activeGroup: "",
        login: "",
        email: "",
        autologinHash: ""
      }
    },
    mounted() {
      this.login = new URL(window.location.href).searchParams.get("login");
      this.email = new URL(window.location.href).searchParams.get("email");
      this.autologinHash = new URL(window.location.href).searchParams.get("autologinHash");

      this.activeGroup = this.$route.meta.groupName;

      getModulesInGroups().then(res => {
        this.moduleGroups = res
      });
    },
    methods: {
      isActive(groupeName) {
        if (groupeName == this.activeGroup) {
          return "dropdown active";
        }
        else return "dropdown";
      }
    },
    watch: {
      '$route.meta.groupName': {
        handler: function (groupName) {
          this.activeGroup = groupName;
        }
      }
    }
  }
</script>

<style scoped>
  .nav {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 175px;
    background-color: #F6F6F6;
    padding: 60px 0;
    background: url("../assets/bg-header.jpg") center/cover no-repeat;
    color: #FFF;
    font-size: 14px;
  }

  .nav-inner {
    display: flex;
    justify-content: space-between;
    width: 1140px;
    max-width: 1140px;
    max-height: 100%;
    margin: 0 auto;
  }

    .nav-inner a img {
      height: 100%;
      width: auto;
    }

  .mme .nav-inner {
    align-items: center;
  }

  .breadcrumb {
    height: 53px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    margin-bottom: 11px !important;
    padding-left: 50px;
    padding-right: 50px;
  }
    .breadcrumb > div {
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 5px;
      border-bottom: solid 5px transparent;
    }

      .breadcrumb > div.active {
        border-bottom: solid 5px #A7C13C;
      }

  .mme .breadcrumb > div.active {
    border-bottom-color: black;
  }

    .breadcrumb > div:hover {
        background-color: #FAFAFA;
    }

  .breadcrumb > div > .dropdown-title > a,
  .dropdown-sub a {
    text-decoration: none;
    color: #000000;
    font-family: "DIN Bold";
    font-size: 13px;
  }

  .dropdown {
    position: relative;
    cursor: pointer;
    z-index: 999998;
  }

  .dropdown-sub {
    visibility: hidden;
    position: absolute;
    min-width: 300px;
    /*min-width: 100%;*/
    top: 100%;
    left: 0%;
    background-color: #FFFFFF;
    z-index: 999998;
  }

  .dropdown:hover .dropdown-sub {
    visibility: visible;
  }


  .dropdown-sub > .dropdown-option {
      padding: 10px;
  }

    .dropdown-sub > .dropdown-option:hover {
      background-color: #FAFAFA;
    }


    /*MENU ADMIN*/
  .nav-admin {
    background: #FFFFFF;
    height: 60px;
    border-bottom: solid 1px #6EB085;
    box-shadow: 5px 0 9px -4px rgba(0,0,0,.75);
    padding: .5rem 1rem;
  }

    .nav-admin > .navbar-brand {
      max-height: 100%;
      max-width: none;
      height: 100%;
      padding-top: 0;
      padding-bottom: 0;
    }

        .nav-admin > .navbar-brand > img {
          max-height: 100%;
          max-width: none;
          height: 100%;
          cursor: pointer;
        }

    .nav-admin > .user-infos {
      /*border: 1px solid #6EB085;*/
      /*background: linear-gradient(to left, #6EB085, #7ED321);*/
      padding: 6px;
      border-radius: 5px;
      float: right;
    }

      .nav-admin > .user-infos span {
        display: inline-block;
        vertical-align: middle;
        color: rgb(44, 62, 80);
        font-weight: 700;
      }

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue